/**
 * Serwis zarządzający przyciskami dodawania do porównywarki
 * Odpowiada za synchronizację stanu przycisków "dodaj do porównania" oraz ich analitykę
 */
app.service('comparisonButtonManager', function(comparisonState, simpleToastr, broker) {
	let $compareToggleButton;
	const MAX_PRODUCTS_PER_GROUP = comparisonState.getMaxProductsPerGroup();

	function setElements() {
		$compareToggleButton = $('.js-add-to-compare');
	}

	function updateButtonState(plu, isActive) {
		const $btn = $compareToggleButton.filter('[data-plu="' + plu + '"]');
		
		if (isActive) {
			$btn.addClass('compare-button-active');
			UA.pageInteraction('Porównanie', 'Dodaj do Porównania');
		} else {
			$btn.removeClass('compare-button-active');
			UA.pageInteraction('Porównanie', 'Usuń z Porównania');
		}
	}

	function toggleProduct(product) {
		const result = comparisonState.toggleProduct(product);

		if (!result.success && result.reason === 'product_limit_reached') {
			const content = `
				<h2>Możesz porównać maksymalnie ${MAX_PRODUCTS_PER_GROUP} produktów tej samej kategorii</h2>
				<p>W porównaniu masz już ${MAX_PRODUCTS_PER_GROUP} produktów z kategorii ${result.groupName}. Chcesz dodać kolejny? Najpierw usuń jeden z obecnych, a potem dodaj nowy.</p>
			`;
			simpleToastr.generate(content, { modifier: 'modifier-warning'});
			return;
		}

		if (!result.success && result.reason === 'category_limit_reached') {
			const content = `
				<h2>Możesz jednocześnie porównywać produkty z maksymalnie ${result.limit} kategorii</h2>
				<p>Porównujesz już produkty z ${result.limit} kategorii. Aby dodać nową kategorię, usuń jedną z kategorii w porównywarce lub zapisz ją w swoim koncie klienta.</p>
			`;
			simpleToastr.generate(content, { modifier: 'modifier-warning'});
			return;
		}
		
		if (result.action === 'added') {
			updateButtonState(product.plu, true);
		} else if (result.action === 'removed') {
			updateButtonState(product.plu, false);
		}
		
		// Emit broker event for comparisonBar to listen to
		broker.trigger('COMPARISON_PRODUCT_TOGGLED');
	}

	function syncAllButtons() {
		const allProducts = comparisonState.getAllProducts();
		const productPLUs = allProducts.map(p => p.id);

		$compareToggleButton.each(function() {
			const $btn = $(this);
			const plu = $btn.attr('data-plu');
			
			if (productPLUs.includes(plu)) {
				$btn.addClass('compare-button-active');
			} else {
				$btn.removeClass('compare-button-active');
			}
		});
	}

	function initSyncAcrossBrowserTabs() {
		window.addEventListener('storage', function(e) {
			if (comparisonState.shouldSync(e.key)) {
				syncAllButtons();
				// Emit broker event for comparisonBar to update
				broker.trigger('COMPARISON_STORAGE_CHANGED');
			}
		});
	}

	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			broker.on('PAGE_CHANGE', init);
		}
		setElements();
		syncAllButtons();
		initSyncAcrossBrowserTabs();
	}

	return {
		init,
		toggleProduct,
		updateButtonState,
		syncAllButtons
	};
});
